import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
const QrPage = () => {
  const [qrCode, setQrCode] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const storedQR = localStorage.getItem("generatedQRCode");
    if (storedQR) {
      setQrCode(storedQR);
    }
  }, []);

  const handleDownload = () => {
    if (!qrCode) return;

    const link = document.createElement("a");
    link.href = qrCode;
    link.download = "qr-code.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleSignOut = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <header className="hide_for_confirmation_page">
        <div className="homebanner">
          <img src="homebanner.png" alt="HomePage Banner" />
        </div>
        <div className="homelogo">
          <img src="church_logo_no_bg.png" alt="Church Logo" />
        </div>
        <div className="homebody6">
          <button onClick={handleSignOut}>Sign Out</button>
        </div>
        <div className="cross_icon">
          <img src="cross_icon.png" alt="Cross Icon" />
        </div>
      </header>
      <header className="hide_for_media_query">
        <div className="media_query_banner media_query_banner1 ">
          <img src="banner_md.png" alt="Media Query Banner" />
          <img
            src="church_logo_no_bg.png"
            alt="Church Avatar No BG"
            className="media_query_logo media_query_logo1"
          />
        </div>
        <div className="cross_icon">
          <img src="cross_icon.png" alt="Church Cross Icon" />
        </div>
      </header>
      <footer>
        <div className="homebody">
          <div className="homebody1">
            <h1>QR Code Generated</h1>
          </div>
          <div className="qr-gen">
            {qrCode ? (
              <img src={qrCode} alt="Generated QR" />
            ) : (
              <p>Loading QR Code...</p>
            )}
          </div>
          <button
            className="homebody2 qrbody"
            onClick={handleDownload}
            disabled={!qrCode}
          >
            <h5>Download Image</h5>
          </button>
          <div className="homebody5_signout_qrpage hide_for_homepage homebody5_qrpage">
            <button onClick={handleSignOut}>Sign Out</button>
          </div>
        </div>
      </footer>
    </>
  );
};

export default QrPage;
